
const side_show_effect = (sectionClass, side1, side2) => {
    window.addEventListener('scroll',()=>{
        const section = document.querySelector(sectionClass);
        const left_side = document.querySelector(side1);
        const right_side = document.querySelector(side2);
        const contentPosition = section.getBoundingClientRect().top;
        const screenPosition = window.innerHeight/1.7

        if(contentPosition < screenPosition){
            right_side.classList.add('right-active')
            left_side.classList.add('left-active')
            console.log(2000);
        }else{
            left_side.classList.remove('left-active')
            right_side.classList.remove('right-active')
        }
    })
};

export default side_show_effect;